import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import en from "./locales/en.json"
import ar from "./locales/ar.json"
import { getStoredLocale } from "@/lib/utils.ts"

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    ar: {
      translation: ar,
    },
  },

  lng: getStoredLocale() || "en",
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },
})

export default i18n
